import { useEffect, useRef } from 'react';
import { getBookUrlFromDOM } from '../../utils/book';
import GenericModal from '../ibok-core/module/GenericModal';
import ContactBookPreview from './ContactBookPreview';

const buildLoginUrl = (classified) => {
  const query = window.location.search
    .replace(/^\?/, '')
    .split('&')
    .filter((param) => param && param.split('=')[0] !== 'focus_on');

  query.push(`focus_on=${encodeURIComponent(classified.id)}`);

  return `/logg_inn?redirect=${encodeURIComponent(`${window.location.pathname}?${query.join('&')}`)}`;
};

const SignInPrompt = ({ classified, onClose, coverUrl: explicitCoverUrl = null }) => {
  const coverUrl = explicitCoverUrl || getBookUrlFromDOM(classified.bookId);
  const loginRef = useRef(null);

  // Autofocus on the sign-in button
  useEffect(() => {
    loginRef.current.focus();
  }, []);

  return <GenericModal title="Logg inn for å opprette samtaler" onDismiss={onClose}>
    <ContactBookPreview classified={classified} coverUrl={coverUrl}/>

    <p>
      For at vårt nye chattesystem skal fungere optimalt,
      trenger vi nå at alle brukere må være innlogget før dere kan ta kontakt med selgere.
    </p>

    <div className="columns has-no-wrapping is-reversed">
      <a href={buildLoginUrl(classified)} ref={loginRef} className="button">Logg inn</a>
      <button className="button plain" onClick={onClose}>Avbryt</button>
    </div>
  </GenericModal>;
};

export default SignInPrompt;
